import { formatDateString } from "src/utils/format-date"
import { formatCpfCnpj } from "src/v2/utils/formatter/format-cpf-cnpj"
import { formatDecimalSeparator } from "src/v2/utils/formatter/format-number"
import { normalizeExternalHttpUrl } from "src/v2/utils/normalize-href"
import { FIELD_TYPE } from "./company-registration-config"

export const isEmptyRegistrationValue = (value) => value === null || value === undefined || value === ""

export const getFormattedReadOnlyFieldValue = (field, row) => {
    const sourceRow = row ?? {}
    const value = field.detailValue ? field.detailValue(sourceRow[field.name], sourceRow) : sourceRow[field.name]

    if (isEmptyRegistrationValue(value)) return null
    if (field.type === FIELD_TYPE.DATE) return formatDateString(value, null)
    if (field.displayType === "decimal") return formatDecimalSeparator(value)
    if (["CPFCNPJ", "CNPJAuditor"].includes(field.name)) return formatCpfCnpj(value)

    return value
}

export const buildReadOnlyRegistrationFields = (definition, row) => {
    const sourceRow = row ?? {}

    return definition.fields
        .filter((field) => (
            field.visibleInDetails !== false
            && (!field.visibleInDetailsWhen || field.visibleInDetailsWhen(sourceRow[field.name], sourceRow))
        ))
        .map((field) => {
            const value = getFormattedReadOnlyFieldValue(field, sourceRow)

            return {
                ...field,
                value: isEmptyRegistrationValue(value) ? (field.placeholder ?? "-") : value,
                rawValue: sourceRow[field.name],
                externalUrl: field.detailLink && !isEmptyRegistrationValue(sourceRow[field.name])
                    ? normalizeExternalHttpUrl(value) ?? null
                    : null,
            }
        })
}
